(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 75557:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(59600);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 49187:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ RemoteImage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(86010);






var defaultProps = {
    className: null
};
var propTypes = {
    src: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string.isRequired),
    alt: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string.isRequired),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string)
};
var cloudinaryLoader = function(param) {
    var src = param.src;
    if (/^(f|ht)tps?:\/\//i.test(src)) {
        return src;
    }
    return "https://res.cloudinary.com/aibesorg/image/upload/f_auto,q_auto,fl_lossy,f_avif/".concat(src);
};
function RemoteImage(_param) {
    var src = _param.src, alt = _param.alt, className = _param.className, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "src",
        "alt",
        "className"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        src: src,
        alt: alt,
        loader: cloudinaryLoader,
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)("block h-auto max-w-full", className),
        placeholder: "blur",
        blurDataURL: "data:image/svg+xml;base64,"
    }, rest));
};
RemoteImage.defaultProps = defaultProps;
RemoteImage.propTypes = propTypes;


/***/ }),

/***/ 31233:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Image; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./src/components/Image/Picture.js


var defaultProps = {};
var propTypes = {
    children: (prop_types_default()).node.isRequired
};
function Picture(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("picture", {
        children: children
    });
};
Picture.defaultProps = defaultProps;
Picture.propTypes = propTypes;

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
;// CONCATENATED MODULE: ./src/components/Image/Img.js



/* eslint-disable @next/next/no-img-element */ 


var Img_defaultProps = {
    fluid: true,
    title: null,
    className: null
};
var Img_propTypes = {
    src: (prop_types_default()).string.isRequired,
    alt: (prop_types_default()).string.isRequired,
    fluid: (prop_types_default()).bool,
    title: (prop_types_default()).string,
    className: (prop_types_default()).string
};
function Img(_param) {
    var src = _param.src, alt = _param.alt, fluid = _param.fluid, title = _param.title, className = _param.className, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "src",
        "alt",
        "fluid",
        "title",
        "className"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", (0,_object_spread/* default */.Z)({
        src: src,
        alt: alt,
        title: title,
        className: (0,clsx_m/* default */.Z)(fluid && "h-auto max-w-full", className),
        loading: "lazy"
    }, rest));
}
Img.defaultProps = Img_defaultProps;
Img.propTypes = Img_propTypes;
var ImgForwardRef = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Img, (0,_object_spread/* default */.Z)({
        ref: ref
    }, props));
});
ImgForwardRef.displayName = "ImgForwardRef";
/* harmony default export */ var Image_Img = (ImgForwardRef);

;// CONCATENATED MODULE: ./src/components/Image/isRemote.js
function isRemote(src) {
    return src.indexOf("//") !== -1;
};

;// CONCATENATED MODULE: ./src/components/Image/localImageSource.js
function localImageSource(src) {
    return "/images/".concat(src);
};

;// CONCATENATED MODULE: ./src/components/Image/Source.js


var Source_defaultProps = {
    sizes: null,
    srcset: null,
    media: "all"
};
var Source_propTypes = {
    sizes: (prop_types_default()).string,
    srcset: (prop_types_default()).string,
    type: (prop_types_default()).string.isRequired,
    media: prop_types_default().oneOfType([
        prop_types_default().oneOf([
            "all",
            "print",
            "screen",
            "speech"
        ]),
        (prop_types_default()).string, 
    ])
};
function Source(param) {
    var sizes = param.sizes, srcset = param.srcset, type = param.type, media = param.media;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
        sizes: sizes,
        srcSet: srcset,
        type: type,
        media: media
    });
};
Source.defaultProps = Source_defaultProps;
Source.propTypes = Source_propTypes;

;// CONCATENATED MODULE: ./src/components/Image/renderSources.js


function renderSources(sources) {
    var keys = Object.keys(sources);
    if (keys === null || keys.length === 0) {
        return null;
    }
    return keys.map(function(type, index) {
        var src = sources[type];
        var srcSet = src;
        var sizes = null;
        if (Array.isArray(src) === true) {
            srcSet = src[0];
            sizes = src[1];
        }
        return renderSource(index, type, srcSet, sizes);
    });
};
function renderSource(index, type, srcSet) {
    var sizes = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Source, {
        type: type,
        srcSet: srcSet,
        sizes: sizes
    }, "source-".concat(index));
}

;// CONCATENATED MODULE: ./src/components/Image/Image.js










var Image_defaultProps = {
    fluid: false,
    sources: null,
    srcSet: null,
    sizes: null,
    className: ""
};
var Image_propTypes = {
    src: (prop_types_default()).string.isRequired,
    sources: prop_types_default().oneOfType([
        (prop_types_default()).string,
        (prop_types_default()).object
    ]),
    srcSet: (prop_types_default()).string,
    sizes: (prop_types_default()).string,
    fluid: (prop_types_default()).bool,
    className: (prop_types_default()).string
};
function Image(_param) {
    var src = _param.src, sources = _param.sources, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "src",
        "sources"
    ]);
    var hasSources = sources && sources.length !== 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Picture, {
        children: [
            hasSources && renderSources(sources),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image_Img, (0,_object_spread/* default */.Z)({
                src: isRemote(src) ? src : localImageSource(src)
            }, rest))
        ]
    });
}
Image.defaultProps = Image_defaultProps;
Image.propTypes = Image_propTypes;
var ImageForwardRef = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) /*#__PURE__*/ {
    var alt = _param.alt, props = (0,_object_without_properties/* default */.Z)(_param, [
        "alt"
    ]);
    return (0,jsx_runtime.jsx)(Image, (0,_object_spread/* default */.Z)({
        ref: ref,
        alt: alt
    }, props));
});
ImageForwardRef.displayName = "ImageForwardRef";
/* harmony default export */ var Image_Image = (ImageForwardRef);

;// CONCATENATED MODULE: ./src/components/Image/index.js

/* harmony default export */ var components_Image = (Image_Image);


/***/ }),

/***/ 86602:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Section; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
;// CONCATENATED MODULE: ./src/components/Section/Section.js



var defaultProps = {
    offset: false,
    className: "",
    children: null
};
var propTypes = {
    offset: (prop_types_default()).bool,
    className: (prop_types_default()).string,
    children: (prop_types_default()).node
};
function Section(param) {
    var offset = param.offset, className = param.className, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: (0,clsx_m/* default */.Z)(offset && "py-10 lg:py-16", className),
        children: children
    });
};
Section.defaultProps = defaultProps;
Section.propTypes = propTypes;

;// CONCATENATED MODULE: ./src/components/Section/index.js

/* harmony default export */ var components_Section = (Section);


/***/ }),

/***/ 23638:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ domain_CustomerLogos; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./src/components/Container/index.js
var Container = __webpack_require__(30341);
// EXTERNAL MODULE: ./src/components/Image/index.js + 7 modules
var Image = __webpack_require__(31233);
// EXTERNAL MODULE: ./src/components/Image/RemoteImage.js
var RemoteImage = __webpack_require__(49187);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
;// CONCATENATED MODULE: ./src/domain/CustomerLogos/CustomerLogos.js







var defaultProps = {
    className: "lg:px-20",
    customers: []
};
var propTypes = {
    className: (prop_types_default()).string,
    customers: prop_types_default().arrayOf(prop_types_default().shape({
        logo: (prop_types_default()).string,
        title: (prop_types_default()).string,
        url: (prop_types_default()).string
    }))
};
function CustomerLogos(param) {
    var className = param.className, customers = param.customers;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.ZP, {
        className: (0,clsx_m/* default */.Z)(className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex items-center justify-center",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-4 justify-center",
                children: customers.map(function(param, idx) {
                    var logo = param.logo, title = param.title, url = param.url;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: typeof logo === "string" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(RemoteImage/* default */.Z, {
                            src: logo,
                            alt: title,
                            width: 300,
                            height: 190
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, (0,_object_spread/* default */.Z)({
                            title: title
                        }, logo))
                    }, "customer-logo-".concat(idx, "-with-").concat(url));
                })
            })
        })
    });
};
CustomerLogos.defaultProps = defaultProps;
CustomerLogos.propTypes = propTypes;

;// CONCATENATED MODULE: ./src/domain/CustomerLogos/index.js

/* harmony default export */ var domain_CustomerLogos = (CustomerLogos);


/***/ }),

/***/ 77390:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dt": function() { return /* binding */ udla; },
/* harmony export */   "O2": function() { return /* binding */ nestleSimple; },
/* harmony export */   "P$": function() { return /* binding */ iess; },
/* harmony export */   "Vq": function() { return /* binding */ modernaAlimentos; },
/* harmony export */   "az": function() { return /* binding */ procredit; },
/* harmony export */   "bR": function() { return /* binding */ soltein; },
/* harmony export */   "el": function() { return /* binding */ soyHincha; },
/* harmony export */   "pQ": function() { return /* binding */ nestle; },
/* harmony export */   "tP": function() { return /* binding */ technisys; }
/* harmony export */ });
/* unused harmony exports stackbuilders, salica, klever, farmaenlace, megaprofer */
var iess = {
    logo: "v1642656757/clientes/iess_jov8bv.png",
    title: "Instituto Ecuatoriano de Seguridad Social",
    url: "https://www.iess.gob.ec/"
};
var nestle = {
    logo: "v1642656870/clientes/nestle_dgfaal.png",
    title: "Nestle Ecuador",
    url: "https://www.nestle.com.ec/"
};
var nestleSimple = {
    logo: "v1642656903/clientes/nestle-simple_j6jz9n.png",
    title: "Nestle Ecuador",
    url: "https://www.nestle.com.ec/"
};
var soltein = {
    logo: "v1610716328/clientes/soltein_xie3pe.png",
    title: "Soltein",
    url: "https://www.soltein.net/"
};
var soyHincha = {
    logo: "v1610716328/clientes/soy-hincha_rualzx.png",
    title: "Soy Hincha",
    url: "https://www.soyhincha.com/"
};
var udla = {
    logo: "v1642656789/clientes/udla_ljwmwd.png",
    title: "Universidad de las Am\xe9ricas",
    url: "https://www.udla.edu.ec/"
};
var modernaAlimentos = {
    logo: "v1642656833/clientes/moderna-alimentos_s8ibnv.png",
    title: "Alimentos Moderna",
    url: "https://www.moderna.com.ec/"
};
var stackbuilders = {
    logo: "v1615002897/clientes/stackbuilders_b5h22c.png",
    title: "Stack Builders"
};
var technisys = {
    logo: "v1642492527/clientes/technisys_tpocwc.png",
    title: "Technisys"
};
var salica = {
    logo: "v1642492527/clientes/salica_vjaqro.png",
    title: "Salica"
};
var klever = {
    logo: "v1642494547/clientes/klever_pweeo6.png",
    title: "Klever Team"
};
var farmaenlace = {
    logo: "v1642492527/clientes/farmaenlace_bamb3a.png",
    title: "Farmaenlace"
};
var megaprofer = {
    logo: "v1642492965/clientes/megaprofer_tafkg9.png",
    title: "Megaprofer"
};
var procredit = {
    logo: "v1642656694/clientes/banco-procredit_e89oem.png",
    title: "Banco ProCredit"
};


/***/ }),

/***/ 58645:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useInterval; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function useInterval(callback, delay) {
    var savedCallback = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        savedCallback.current = callback;
    }, [
        callback
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (delay !== null) {
            var id = setInterval(function() {
                return savedCallback.current();
            }, delay);
            return function() {
                return clearInterval(id);
            };
        }
        return null;
    }, [
        delay
    ]);
};


/***/ }),

/***/ 41959:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZP": function() { return /* binding */ usePageVisibility; }
/* harmony export */ });
/* unused harmony exports getBrowserVisibilityProp, getBrowserDocumentHiddenProp, getIsDocumentHidden */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function getBrowserVisibilityProp() {
    if (typeof document.hidden !== "undefined") {
        // Opera 12.10 and Firefox 18 and later support
        return "visibilitychange";
    } else if (typeof document.msHidden !== "undefined") {
        return "msvisibilitychange";
    } else if (typeof document.webkitHidden !== "undefined") {
        return "webkitvisibilitychange";
    }
}
function getBrowserDocumentHiddenProp() {
    if (typeof document.hidden !== "undefined") {
        return "hidden";
    } else if (typeof document.msHidden !== "undefined") {
        return "msHidden";
    } else if (typeof document.webkitHidden !== "undefined") {
        return "webkitHidden";
    }
}
function getIsDocumentHidden() {
    return typeof document !== "undefined" && !document[getBrowserDocumentHiddenProp()];
}
function usePageVisibility() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(getIsDocumentHidden()), isVisible = ref[0], setIsVisible = ref[1];
    var onVisibilityChange = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        setIsVisible(getIsDocumentHidden());
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var visibilityChange = getBrowserVisibilityProp();
        document.addEventListener(visibilityChange, onVisibilityChange, false);
        return function() {
            document.removeEventListener(visibilityChange, onVisibilityChange);
        };
    });
    return isVisible;
};


/***/ }),

/***/ 59600:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Home; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/Section/index.js + 1 modules
var Section = __webpack_require__(86602);
// EXTERNAL MODULE: ./src/components/Container/index.js
var Container = __webpack_require__(30341);
// EXTERNAL MODULE: ./src/components/Link/index.js + 2 modules
var Link = __webpack_require__(48300);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./src/hooks/useInterval.js
var useInterval = __webpack_require__(58645);
// EXTERNAL MODULE: ./src/hooks/usePageVisibility.js
var usePageVisibility = __webpack_require__(41959);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/transitions/transition.esm.js + 4 modules
var transition_esm = __webpack_require__(6654);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./src/components/Image/index.js + 7 modules
var components_Image = __webpack_require__(31233);
// EXTERNAL MODULE: ./src/components/Image/RemoteImage.js
var RemoteImage = __webpack_require__(49187);
;// CONCATENATED MODULE: ./src/view/Hero/HeroImage.js







var defaultProps = {
    alt: "",
    title: "",
    url: "",
    active: false,
    color: "gray-100",
    isNew: false,
    useRemote: true
};
var propTypes = {
    id: (prop_types_default()).string.isRequired,
    title: (prop_types_default()).string,
    color: (prop_types_default()).string,
    url: (prop_types_default()).string,
    alt: (prop_types_default()).string,
    active: (prop_types_default()).bool,
    image: (prop_types_default()).string.isRequired,
    imageSources: prop_types_default().oneOfType([
        (prop_types_default()).string,
        (prop_types_default()).object
    ]),
    isNew: (prop_types_default()).bool,
    useRemote: (prop_types_default()).bool
};
function HeroImage(param) {
    var id = param.id, title = param.title, color = param.color, url = param.url, image = param.image, imageSources = param.imageSources, alt = param.alt, active = param.active, isNew = param.isNew, useRemote = param.useRemote;
    var imageContent;
    if (image.indexOf("//") !== -1 || useRemote) {
        imageContent = /*#__PURE__*/ (0,jsx_runtime.jsx)(RemoteImage/* default */.Z, {
            src: image,
            alt: alt,
            width: 710,
            height: 800
        });
    } else {
        imageContent = /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Image/* default */.Z, {
            title: title,
            src: image,
            sources: imageSources,
            className: "pointer-events-none select-none lg:h-full",
            alt: alt,
            width: 710,
            height: 800
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,clsx_m/* default */.Z)("relative max-h-full lg:absolute lg:inset-0 lg:mt-2 lg:h-full lg:w-full", active === false && "z-10", active === true && "z-20"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(transition_esm/* Transition */.u, {
            show: active,
            unmount: false,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(transition_esm/* Transition.Child */.u.Child, {
                    enter: "transition ease-in-out duration-1000 transform",
                    enterFrom: "opacity-0 translate-y-2 translate-x-4 scale-95",
                    enterTo: "opacity-100 translate-y-0 translate-x-0 scale-100",
                    leave: "transition ease-in-out duration-1000 transform",
                    leaveFrom: "opacity-100 translate-x-0 scale-100",
                    leaveTo: "opacity-0 translate-x-2 scale-95",
                    unmount: false,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "pointer-events-none relative z-0 max-h-full select-none lg:h-full",
                        children: imageContent
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "relative z-20 lg:absolute lg:bottom-0 lg:right-0 lg:mr-10",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(transition_esm/* Transition.Child */.u.Child, {
                        enter: "transition ease-in-out duration-1000 transform transform-gpu",
                        enterFrom: "translate-y-10 opacity-0",
                        enterTo: "translate-y-0 opacity-100",
                        leave: "transition ease-in-out duration-700 transform",
                        leaveFrom: "translate-y-0 opacity-100",
                        leaveTo: "translate-y-10 opacity-0",
                        unmount: false,
                        children: [
                            isNew && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mb-2 inline-flex rounded-full bg-green-500 bg-gradient-to-t from-green-600 to-green-500 px-4 text-xs font-semibold leading-6 text-white shadow-sm ring-1 ring-black ring-opacity-10 lg:text-sm",
                                children: "Nueva"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                href: url,
                                className: "relative flex cursor-pointer rounded-full shadow-lg transition duration-300 ease-in-out hover:shadow-xl lg:shadow-xl lg:hover:shadow-2xl",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "inline-flex flex-1 select-none items-center space-x-2 rounded-full bg-gray-900 bg-gradient-to-t from-black to-gray-900 py-2 pr-4 pl-2 text-xs font-medium leading-5 text-gray-300 lg:text-sm",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: (0,clsx_m/* default */.Z)("h-5 w-5 select-none rounded-full", color)
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "block",
                                            children: title
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            className: "h-5 w-5 text-white text-opacity-50",
                                            viewBox: "0 0 20 20",
                                            fill: "currentColor",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                fillRule: "evenodd",
                                                d: "M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z",
                                                clipRule: "evenodd"
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            ]
        })
    }, id);
};
HeroImage.defaultProps = defaultProps;
HeroImage.propTypes = propTypes;

;// CONCATENATED MODULE: ./src/view/Hero/pictures.remote.js
/* harmony default export */ var pictures_remote = ([
    {
        id: "official-product-backlog-management-certification",
        title: "Official Product Backlog Management Certification",
        color: "bg-teal-700",
        url: "/certificaciones/official-product-backlog-management-certification/",
        image: "w_820,h_910/v1705344536/personas/twyy7ze6bqo0gipfjoyn.png",
        isNew: true
    },
    {
        id: "official-agile-metrics-certification",
        title: "Official Agile Metrics Certification",
        color: "bg-cyan-600",
        url: "/certificaciones/official-agile-metrics-certification/",
        image: "w_820,h_910/v1682566861/personas/official-agile-metrics-certification_lyjqjt.png"
    },
    {
        id: "official-kanban-practitioner-certification",
        title: "Official Kanban Practitioner Certification",
        color: "bg-fuchsia-600",
        url: "/certificaciones/official-kanban-practitioner-certification/",
        image: "w_820,h_910/v1642658497/personas/official-kanban-certification_df3tah.png"
    },
    {
        id: "official-scrum-fundamentals-certification",
        title: "Official Scrum Fundamentals Certification",
        color: "bg-yellow-600",
        url: "/certificaciones/official-scrum-fundamentals-certification/",
        image: "w_820,h_910/v1611708369/personas/official-scrum-fundamentals-certification_dm3r9u.png"
    },
    {
        id: "official-scrum-master-certification",
        title: "Official Scrum Master Certification",
        color: "bg-blue-500",
        url: "/certificaciones/official-scrum-master-certification/",
        image: "w_820,h_910/v1610683720/personas/official-scrum-master-certification_lov3hh.png",
        sources: {
            "image/webp": "v1610683717/personas/official-scrum-master-certification_kwqtco.webp"
        }
    },
    {
        id: "official-product-owner-certification",
        title: "Official Product Owner Certification",
        color: "bg-green-400",
        url: "/certificaciones/official-product-owner-certification/",
        image: "w_820,h_910/v1610683733/personas/official-product-owner-certification_pvac3m.png",
        sources: {
            "image/webp": "v1610683729/personas/official-product-owner-certification_kjjlhv.webp"
        }
    },
    {
        id: "official-scrum-developer-certification",
        title: "Official Scrum Developer Certification",
        color: "bg-yellow-500",
        url: "/certificaciones/official-scrum-developer-certification/",
        image: "w_820,h_910/v1611711515/personas/official-scrum-developer-certification_q0diio.png"
    },
    {
        id: "official-scrum-trainer-certification",
        title: "Official Scrum Trainer Certification",
        color: "bg-purple-500",
        url: "/certificaciones/official-scrum-trainer-certification/",
        image: "w_820,h_910/v1610683720/personas/official-scrum-trainer-certification_vcylug.png",
        sources: {
            "image/webp": "v1610683717/personas/official-scrum-trainer-certification_uk3xyh.webp"
        }
    },
    {
        id: "official-agile-coach-certification",
        title: "Official Agile Coach Certification",
        color: "bg-red-500",
        url: "/certificaciones/official-agile-coach-certification/",
        image: "w_820,h_910/v1610683730/personas/official-agile-coach-certification_ng96yw.png",
        sources: {
            "image/webp": "v1610683724/personas/official-agile-coach-certification_ew6ncs.webp"
        }
    },
    {
        id: "official-scrum-master-certification-secondary",
        title: "Official Scrum Master Certification",
        color: "bg-blue-500",
        url: "/certificaciones/official-scrum-master-certification/",
        image: "w_820,h_910/v1610683726/personas/official-scrum-master-certification-secondary_k0knok.png",
        sources: {
            "image/webp": "v1610683728/personas/official-scrum-master-certification-secondary_jknkty.webp"
        }
    },
    {
        id: "official-product-owner-certification-secondary",
        title: "Official Product Owner Certification",
        color: "bg-green-400",
        url: "/certificaciones/official-product-owner-certification/",
        image: "w_820,h_910/v1610683734/personas/official-product-owner-certification-secondary_cajwct.png",
        sources: {
            "image/webp": "v1610683734/personas/official-product-owner-certification-secondary_ukkosx.webp"
        }
    },
    {
        id: "official-scrum-developer-certification-secondary",
        title: "Official Scrum Developer Certification",
        color: "bg-yellow-500",
        url: "/certificaciones/official-scrum-developer-certification/",
        image: "w_820,h_910/v1611709029/personas/official-scrum-developer-certification-secondary_yvsvrw.png"
    },
    {
        id: "official-scrum-trainer-certification-secondary",
        title: "Official Scrum Trainer Certification",
        color: "bg-purple-500",
        url: "/certificaciones/official-scrum-trainer-certification/",
        image: "w_820,h_910/v1610683720/personas/official-scrum-trainer-certification-secondary_mlpqsw.png",
        sources: {
            "image/webp": "v1610683724/personas/official-scrum-trainer-certification-secondary_bmolry.webp"
        }
    },
    {
        id: "official-agile-coach-certification-secondary",
        title: "Official Agile Coach Certification",
        color: "bg-red-500",
        url: "/certificaciones/official-agile-coach-certification/",
        image: "w_820,h_910/v1610683731/personas/official-agile-coach-certification-secondary_oipgll.png",
        sources: {
            "image/webp": "v1610683731/personas/official-agile-coach-certification-secondary_wyliwf.webp"
        }
    }, 
]);

;// CONCATENATED MODULE: ./src/view/Hero/HeroCarousel.js







var HeroCarousel_defaultProps = {
    delay: 7000
};
var HeroCarousel_propTypes = {
    delay: (prop_types_default()).number
};
function HeroCarousel(param) {
    var delay = param.delay;
    var ref = (0,react.useState)(0), activeIndex = ref[0], setActiveIndex = ref[1];
    var isPageVisible = (0,usePageVisibility/* default */.ZP)();
    (0,useInterval/* default */.Z)(function() {
        if (isPageVisible) {
            var nextIndex = activeIndex + 1;
            if (nextIndex > pictures_remote.length - 1) {
                nextIndex = 0;
            }
            setActiveIndex(nextIndex);
        }
    }, delay);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "z-0 hidden w-full lg:absolute lg:right-0 lg:bottom-0 lg:top-0 lg:z-0 lg:block",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "relative z-20 lg:absolute lg:top-0 lg:bottom-0 lg:right-0 lg:w-2/4",
            children: pictures_remote.map(function(param, index) {
                var id = param.id, title = param.title, color = param.color, url = param.url, image = param.image, sources = param.sources, isNew = param.isNew;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroImage, {
                    id: id,
                    title: title,
                    color: color,
                    url: url,
                    image: image,
                    imageSources: sources,
                    alt: title,
                    isNew: !!isNew,
                    active: activeIndex === index
                }, id);
            })
        })
    });
};
HeroCarousel.defaultProps = HeroCarousel_defaultProps;
HeroCarousel.propTypes = HeroCarousel_propTypes;

;// CONCATENATED MODULE: ./src/view/Hero/Hero.js




function Hero() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "lg:hero-min-h xl:hero-min-h relative z-10 overflow-hidden bg-gradient-to-tr from-green-100 to-white py-10 lg:flex",
        role: "banner",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.ZP, {
                className: "relative z-50",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "lg:grid lg:grid-cols-12",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "relative z-50 lg:col-span-7 lg:flex lg:items-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "space-y-4 py-10 leading-tight lg:py-14 xl:pb-20 lg:pr-20",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                        className: "leading-12 mb-8 break-words text-5xl font-extrabold tracking-tight text-gray-900 md:text-5xl xl:text-6xl",
                                        children: [
                                            "Somos la Asociaci\xf3n Iberoamericana\xa0",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "hidden lg:block"
                                            }),
                                            "de\xa0",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "text-green-500 lg:font-black",
                                                children: "Scrum"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-lg text-gray-800 lg:pr-20 lg:text-xl",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "leading-8",
                                            children: "Una organizaci\xf3n Internacional e independiente con enfoque global y acad\xe9mico, que ofrece certificaciones reconocidas a nivel internacional, basadas en el Manifiesto \xc1gil y los principios de Scrum."
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-col space-y-6 pt-5 md:flex-row md:items-center md:space-y-0 md:space-x-4",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "flex",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                    href: "/certificaciones",
                                                    className: "inline-flex justify-center whitespace-nowrap rounded-full bg-green-500 px-10 py-3 text-center text-xl font-semibold leading-none text-white hover:bg-green-600 hover:shadow-lg focus:bg-green-600 focus:outline-none focus:ring-4 focus:ring-green-800 focus:ring-opacity-20 md:text-lg lg:text-xl",
                                                    children: "Certif\xedcate hoy mismo"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "flex",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* default */.Z, {
                                                    href: "/clases",
                                                    className: "inline-flex items-center justify-center px-2 py-4 text-center leading-none text-gray-900 hover:text-gray-700 focus:outline-none",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "text-xl font-bold leading-none md:text-lg ",
                                                            children: "Encuentra un curso"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                            className: "-mb-1 h-6 w-6 text-gray-900 md:h-5 md:w-5",
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            viewBox: "0 0 20 20",
                                                            fill: "currentColor",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                fillRule: "evenodd",
                                                                d: "M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z",
                                                                clipRule: "evenodd"
                                                            })
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroCarousel, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "absolute top-0 bottom-0 right-0 z-0 hidden w-full lg:block",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute top-0 bottom-0 right-0 z-10 mt-20 w-2/5 -skew-y-6 transform rounded-tl-lg bg-gradient-to-l from-green-500 to-transparent"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute top-0 bottom-0 right-0 z-20 mt-40 -mb-20 w-2/4 -skew-y-6 transform rounded-tl-lg bg-gradient-to-l from-green-500 to-transparent"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute top-0 bottom-0 right-0 z-30 mt-80 mb-10 w-2/6 -skew-y-6 transform rounded-tl-lg bg-gradient-to-l from-green-600 to-transparent opacity-50"
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/view/Hero/index.js

/* harmony default export */ var view_Hero = (Hero);

;// CONCATENATED MODULE: ./node_modules/phenomenon/dist/phenomenon.mjs
var t=["x","y","z"],e=function(t){Object.assign(this,{uniforms:{},geometry:{vertices:[{x:0,y:0,z:0}]},mode:0,modifiers:{},attributes:[],multiplier:1,buffers:[]}),Object.assign(this,t),this.prepareProgram(),this.prepareUniforms(),this.prepareAttributes()};e.prototype.compileShader=function(t,e){var i=this.gl.createShader(t);return this.gl.shaderSource(i,e),this.gl.compileShader(i),i},e.prototype.prepareProgram=function(){var t=this.gl,e=this.vertex,i=this.fragment,r=t.createProgram();t.attachShader(r,this.compileShader(35633,e)),t.attachShader(r,this.compileShader(35632,i)),t.linkProgram(r),t.useProgram(r),this.program=r},e.prototype.prepareUniforms=function(){for(var t=Object.keys(this.uniforms),e=0;e<t.length;e+=1){var i=this.gl.getUniformLocation(this.program,t[e]);this.uniforms[t[e]].location=i}},e.prototype.prepareAttributes=function(){void 0!==this.geometry.vertices&&this.attributes.push({name:"aPosition",size:3}),void 0!==this.geometry.normal&&this.attributes.push({name:"aNormal",size:3}),this.attributeKeys=[];for(var t=0;t<this.attributes.length;t+=1)this.attributeKeys.push(this.attributes[t].name),this.prepareAttribute(this.attributes[t])},e.prototype.prepareAttribute=function(e){for(var i=this.geometry,r=this.multiplier,s=i.vertices,n=i.normal,a=new Float32Array(r*s.length*e.size),o=0;o<r;o+=1)for(var h=e.data&&e.data(o,r),u=o*s.length*e.size,f=0;f<s.length;f+=1)for(var c=0;c<e.size;c+=1){var l=this.modifiers[e.name];a[u]=void 0!==l?l(h,f,c,this):"aPosition"===e.name?s[f][t[c]]:"aNormal"===e.name?n[f][t[c]]:h[c],u+=1}this.attributes[this.attributeKeys.indexOf(e.name)].data=a,this.prepareBuffer(this.attributes[this.attributeKeys.indexOf(e.name)])},e.prototype.prepareBuffer=function(t){var e=t.data,i=t.name,r=t.size,s=this.gl.createBuffer();this.gl.bindBuffer(34962,s),this.gl.bufferData(34962,e,35044);var n=this.gl.getAttribLocation(this.program,i);this.gl.enableVertexAttribArray(n),this.gl.vertexAttribPointer(n,r,5126,!1,0,0),this.buffers[this.attributeKeys.indexOf(t.name)]={buffer:s,location:n,size:r}},e.prototype.render=function(t){var e=this,i=this.uniforms,r=this.multiplier,s=this.gl;s.useProgram(this.program);for(var n=0;n<this.buffers.length;n+=1){var a=this.buffers[n],o=a.location,h=a.buffer,u=a.size;s.enableVertexAttribArray(o),s.bindBuffer(34962,h),s.vertexAttribPointer(o,u,5126,!1,0,0)}Object.keys(t).forEach(function(e){i[e].value=t[e].value}),Object.keys(i).forEach(function(t){var r=i[t];e.uniformMap[r.type](r.location,r.value)}),s.drawArrays(this.mode,0,r*this.geometry.vertices.length),this.onRender&&this.onRender(this)},e.prototype.destroy=function(){for(var t=0;t<this.buffers.length;t+=1)this.gl.deleteBuffer(this.buffers[t].buffer);this.gl.deleteProgram(this.program),this.gl=null};var i=function(t){var e=this,i=t||{},r=i.canvas;void 0===r&&(r=document.querySelector("canvas"));var s=i.context;void 0===s&&(s={});var n=i.contextType;void 0===n&&(n="experimental-webgl");var a=i.settings;void 0===a&&(a={});var o=r.getContext(n,Object.assign({alpha:!1,antialias:!1},s));Object.assign(this,{gl:o,canvas:r,uniforms:{},instances:new Map,shouldRender:!0}),Object.assign(this,{devicePixelRatio:1,clearColor:[1,1,1,1],position:{x:0,y:0,z:2},clip:[.001,100]}),Object.assign(this,a),this.uniformMap={float:function(t,e){return o.uniform1f(t,e)},vec2:function(t,e){return o.uniform2fv(t,e)},vec3:function(t,e){return o.uniform3fv(t,e)},vec4:function(t,e){return o.uniform4fv(t,e)},mat2:function(t,e){return o.uniformMatrix2fv(t,!1,e)},mat3:function(t,e){return o.uniformMatrix3fv(t,!1,e)},mat4:function(t,e){return o.uniformMatrix4fv(t,!1,e)}},o.enable(o.DEPTH_TEST),o.depthFunc(o.LEQUAL),!1===o.getContextAttributes().alpha&&(o.clearColor.apply(o,this.clearColor),o.clearDepth(1)),this.onSetup&&this.onSetup(o),window.addEventListener("resize",function(){return e.resize()}),this.resize(),this.render()};i.prototype.resize=function(){var t=this.gl,e=this.canvas,i=this.devicePixelRatio,r=this.position;e.width=e.clientWidth*i,e.height=e.clientHeight*i;var s=t.drawingBufferWidth,n=t.drawingBufferHeight,a=s/n;t.viewport(0,0,s,n);var o=Math.tan(Math.PI/180*22.5),h=[1,0,0,0,0,1,0,0,0,0,1,0,r.x,r.y,(a<1?1:a)*-r.z,1];this.uniforms.uProjectionMatrix={type:"mat4",value:[.5/o,0,0,0,0,a/o*.5,0,0,0,0,-(this.clip[1]+this.clip[0])/(this.clip[1]-this.clip[0]),-1,0,0,-2*this.clip[1]*(this.clip[0]/(this.clip[1]-this.clip[0])),0]},this.uniforms.uViewMatrix={type:"mat4",value:[1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1]},this.uniforms.uModelMatrix={type:"mat4",value:h}},i.prototype.toggle=function(t){t!==this.shouldRender&&(this.shouldRender=void 0!==t?t:!this.shouldRender,this.shouldRender&&this.render())},i.prototype.render=function(){var t=this;this.gl.clear(16640),this.instances.forEach(function(e){e.render(t.uniforms)}),this.onRender&&this.onRender(this),this.shouldRender&&requestAnimationFrame(function(){return t.render()})},i.prototype.add=function(t,i){void 0===i&&(i={uniforms:{}}),void 0===i.uniforms&&(i.uniforms={}),Object.assign(i.uniforms,JSON.parse(JSON.stringify(this.uniforms))),Object.assign(i,{gl:this.gl,uniformMap:this.uniformMap});var r=new e(i);return this.instances.set(t,r),r},i.prototype.remove=function(t){var e=this.instances.get(t);void 0!==e&&(e.destroy(),this.instances.delete(t))},i.prototype.destroy=function(){var t=this;this.instances.forEach(function(e,i){e.destroy(),t.instances.delete(i)}),this.toggle(!1)};/* harmony default export */ var phenomenon = (i);

;// CONCATENATED MODULE: ./node_modules/cobe/dist/index.esm.js
var M="phi",A="theta",T="mapSamples",c="mapBrightness",O="baseColor",s="markerColor",N="glowColor",L="markers",G="diffuse",u="devicePixelRatio",X="dark",m={[M]:"z",[A]:"A",[T]:"j",[c]:"C",[O]:"J",[s]:"K",[N]:"x",[G]:"D",[X]:"E"},{PI:S,sin:P,cos:f}=Math,x=E=>[].concat(...E.map(n=>{let[_,a]=n.location;_=_*S/180,a=a*S/180-S;let e=f(_);return[-e*f(a),P(_),e*P(a),n.size]}),[0,0,0,0]),h=(E,n)=>{let _=(e,t)=>({type:e,value:n[t]}),a=new phenomenon({canvas:E,context:{alpha:!0,stencil:!1,antialias:!0,depth:!1,preserveDrawingBuffer:!1},settings:{[u]:n[u]||1,onSetup:e=>{let t=e.RGB,r=e.UNSIGNED_BYTE,o=e.TEXTURE_2D,R=e.createTexture();e.bindTexture(o,R),e.texImage2D(o,0,t,1,1,0,t,r,new Uint8Array([0,0,0,0]));let i=new Image;i.onload=()=>{e.bindTexture(o,R),e.texImage2D(o,0,t,t,r,i),e.generateMipmap(o);let d=e.getParameter(e.CURRENT_PROGRAM),U=e.getUniformLocation(d,"F");e.texParameteri(o,e.TEXTURE_MIN_FILTER,e.NEAREST),e.texParameteri(o,e.TEXTURE_MAG_FILTER,e.NEAREST),e.uniform1i(U,0)},i.src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQAAAACAAQAAAADMzoqnAAAAAXNSR0IArs4c6QAABA5JREFUeNrV179uHEUAx/Hf3JpbF+E2VASBsmVKTBcpKJs3SMEDcDwBiVJAAewYEBUivIHT0uUBIt0YCovKD0CRjUC4QfHYh8hYXu+P25vZ2Zm9c66gMd/GJ/tz82d3bk8GN4SrByYF2366FNTACIAkivVAAazQdnf3MvAlbNUQfOPAdQDvSAimMWhwy4I2g4SU+Kp04ISLpPBAKLxPyic3O/CCi+Y7rUJbiodcpDOFY7CgxCEXmdYD2EYK2s5lApOx5pEDDYCUwM1XdJUwBV11QQMg59kePSCaPAASQMEL2hwo6TJFgxpg+TgC2ymXPbuvc40awr3D1QCFfbH9kcoqAOkZozpQo0aqAGQRKCog/+tjkgbNFEtg2FffBvBGlSxHoAaAa1u6X4PBAwDiR8FFsrQgeUhfJTSALaB9jy5NCybJPn1SVFiWk7ywN+KzhH1aKAuydhGkbEF4lWohLXDXavlyFgHY7LBnLRdlAP6BS5Cc8RfVDXbkwN/oIvmY+6obbNeBP0JwTuMGu9gTzy1Q4RS/cWpfzszeYwd+CAFrtBW/Hur0gLbJGlD+/OjVwe/drfBxkbbg63dndEDfiEBlAd7ac0BPe1D6Jd8dfbLH+RI0OzseFB5s01/M+gMdAeluLOCAuaUA9Lezo/vSgXoCX9rtEiXnp7Q1W/CNyWcd8DXoS6jH/YZ5vAJEWY2dXFQe2TUgaFaNejCzJ98g6HnlVrsE58sDcYqg+9XY75fPqdoh/kRQWiXKg8MWlJQxUFMPjqnyujhFBE7UxIMjyszk0QwQlFsezImsyvUYYYVED2pk6m0Tg8T04Fwjk2kdAwSACqlM6gRRt3vQYAFGX0Ah7Ebx1H+MDRI5ui0QldH4j7FGcm90XdxD2Jg1AOEAVAKhEFXSn4cKUELurIAKwJ3MArypPscQaLhJFICJ0ohjDySAdH8AhDtCiTuMycH8CXzhH9jUACAO5uMhoAwA5i+T6WAKmmAqnLy80wxHqIPFYpqCwxGaYLt4Dyievg5kEoVEUAhs6pqKgFtDQYOuaXypaWKQfIuwwoGSZgfLsu/XAtI8cGN+h7Cc1A5oLOMhwlIPXuhu48AIvsSBkvtV9wsJRKCyYLfq5lTrQMFd1a262oqBck9K1V0YjQg0iEYYgpS1A9GlXQV5cykwm4A7BzVsxQqo7E+zCegO7Ma7yKgsuOcfKbMBwLC8wvVNYDsANYalEpOAa6zpWjTeMKGwEwC1CiQewJc5EKfgy7GmRAZA4vUVGwE2dPM/g0xuAInE/yG5aZ8ISxWGfYigUVbdyBElTHh2uCwGdfCkOLGgQVBh3Ewp+/QK4CDlR5Ws/Zf7yhCf8pH7vinWAvoVCQ6zz0NX5V/6GkAVV+2/5qsJ/gU8bsxpM8IeAQAAAABJRU5ErkJggg=="}}});return a.add("",{vertex:"attribute vec3 aPosition;uniform mat4 uProjectionMatrix;uniform mat4 uModelMatrix;uniform mat4 uViewMatrix;void main(){gl_Position=uProjectionMatrix*uModelMatrix*uViewMatrix*vec4(aPosition,1.);}",fragment:"precision highp float;uniform vec2 u;uniform vec3 J,K,x;uniform vec4 y[64];uniform float z,A,j,B,C,D,E;uniform sampler2D F;float G=1./j;mat3 H(float a,float b){float c=cos(a),d=cos(b),e=sin(a),f=sin(b);return mat3(d,f*e,-f*c,0.,c,e,f,d*-e,d*c);}vec3 v(vec3 a,out float w){a=a.xzy;float n=max(2.,floor(log2(2.236068*j*3.141593*(1.-a.z*a.z))*.72021));vec2 e=floor(pow(1.618034,n)/2.236068*vec2(1.,1.618034)+.5),b=fract((e+1.)*.618034)*6.283185-3.883222,c=-2.*e,d=vec2(atan(a.y,a.x),a.z-1.),o=floor(vec2(c.y*d.x-b.y*(d.y*j+1.),-c.x*d.x+b.x*(d.y*j+1.))/(b.x*c.y-c.x*b.y));float l=3.141593;vec3 p;for(float f=0.;f<4.;f+=1.){vec2 q=vec2(mod(f,2.),floor(f*.5));float h=dot(e,o+q);if(h>j)continue;int r=int(h)*-1640531527;float s=float(r)*2.328306e-10,i=s*6.283185,g=1.-2.*h*G,k=sqrt(1.-g*g);vec3 m=vec3(cos(i)*k,sin(i)*k,g);float t=length(a-m);if(t<l)l=t,p=m;}w=l;return p.xzy;}void main(){vec2 a=gl_FragCoord.xy/u*2.-1.;a.x*=u.x/u.y;float c=dot(a,a),b;vec3 d=vec3(0.,0.,1.),e=normalize(vec3(a,sqrt(.64-c)));if(c<=.64){vec3 f=e*H(A,z),g=v(f,b);float k=asin(g.y),h=acos(-g.x/cos(k));h=g.z<0.?-h:h;float s=texture2D(F,vec2(h*.5/3.141593,-(k/3.141593+.5))).x,t=smoothstep(8e-3,0.,b),l=dot(e,d),r=pow(l,D)*C,m=s*t*r,L=mix((1.-m)*pow(l,.4),m,E)+.1;gl_FragColor=vec4(J*L,1.);int M=int(B);float n=0.;for(int i=0;i<64;i++){if(i>=M)break;vec4 o=y[i];vec3 p=o.xyz,w=p-f;float q=o.w;if(dot(w,w)>q*q*4.)continue;vec3 N=v(p,b);b=length(N-f),b<q?n+=smoothstep(q*.5,0.,b):0.;}n=min(1.,n*r),gl_FragColor.xyz=mix(gl_FragColor.xyz,K,n),gl_FragColor.xyz+=pow(1.-dot(e,d),4.)*x;}float I=pow(dot(normalize(vec3(-a,sqrt(1.-c))),d),4.)*smoothstep(.1,1.,.2/(c-.64));gl_FragColor+=vec4(I*x,I);}",uniforms:{u:{type:"vec2",value:[n.width,n.height]},z:_("float",M),A:_("float",A),j:_("float",T),C:_("float",c),J:_("vec3",O),K:_("vec3",s),D:_("float",G),x:_("vec3",N),E:_("float",X),y:{type:"vec4",value:x(n[L])},B:{type:"float",value:n[L].length}},mode:4,geometry:{vertices:[{x:-100,y:100,z:0},{x:-100,y:-100,z:0},{x:100,y:100,z:0},{x:100,y:-100,z:0},{x:-100,y:-100,z:0},{x:100,y:100,z:0}]},onRender:({uniforms:e})=>{let t={};if(n.onRender){n.onRender(t);for(let r in m)t[r]!==void 0&&(e[m[r]].value=t[r]);t[L]!==void 0&&(e["y"].value=x(t[L]),e["B"].value=t[L].length),t.width&&t.height&&(e["u"].value=[t.width,t.height])}}}),a};

;// CONCATENATED MODULE: ./src/domain/Globe/Globe.js



function Globe() {
    var canvasRef = (0,react.useRef)();
    (0,react.useEffect)(function() {
        var phi = 0;
        var globe = h(canvasRef.current, {
            devicePixelRatio: 2,
            width: 1320 * 1.6,
            height: 1320 * 1.6,
            phi: 1,
            theta: -0.1,
            dark: 0,
            diffuse: 2.94,
            mapSamples: 20000,
            mapBrightness: 12,
            baseColor: [
                1,
                1,
                1
            ],
            markerColor: [
                0,
                0.8,
                0
            ],
            glowColor: [
                0.8,
                0.8,
                0.8
            ],
            markers: [
                {
                    location: [
                        46.856283,
                        -71.4817758
                    ],
                    size: 0.1
                },
                {
                    location: [
                        27.2789861,
                        -85.1563494
                    ],
                    size: 0.05
                },
                {
                    location: [
                        40.4378698,
                        -3.8196209
                    ],
                    size: 0.06
                },
                {
                    location: [
                        -12.0487766,
                        -77.0442662
                    ],
                    size: 0.061
                },
                {
                    location: [
                        -33.4421472,
                        -70.6851123
                    ],
                    size: 0.031
                },
                {
                    location: [
                        9.6338037,
                        -84.5570323
                    ],
                    size: 0.1
                },
                {
                    location: [
                        19.39068,
                        -99.2836991
                    ],
                    size: 0.031
                },
                {
                    location: [
                        -16.5207007,
                        -68.1941181
                    ],
                    size: 0.021
                },
                {
                    location: [
                        -25.2968361,
                        -57.6681295
                    ],
                    size: 0.031
                }, 
            ],
            onRender: function(state) {
                state.phi = phi;
                phi += 0.001;
            }
        });
        return function() {
            globe.destroy();
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "absolute bottom-0 transform",
        style: {
            width: 1100,
            height: 1100,
            transform: "translateY(60%)"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("canvas", {
            className: "w-full h-full outline-none",
            ref: canvasRef,
            width: 1320,
            height: 1320
        })
    });
};

;// CONCATENATED MODULE: ./src/domain/Globe/index.js


// EXTERNAL MODULE: ./src/domain/CustomerLogos/index.js + 1 modules
var CustomerLogos = __webpack_require__(23638);
// EXTERNAL MODULE: ./src/domain/customers/index.js
var customers = __webpack_require__(77390);
;// CONCATENATED MODULE: ./src/pages/index.js








function Home() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "bg-white",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(view_Hero, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.Z, {
                className: "bg-white py-10 lg:py-20",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.ZP, {
                    className: "space-y-8",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "text-center text-xl tracking-tight lg:text-2xl",
                            children: "Con la confianza de empresas e instituciones reconocidas"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomerLogos/* default */.Z, {
                            customers: [
                                customers/* udla */.Dt,
                                customers/* technisys */.tP,
                                customers/* procredit */.az,
                                customers/* nestleSimple */.O2,
                                customers/* modernaAlimentos */.Vq,
                                customers/* iess */.P$, 
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* default */.Z, {
                                className: "inline-flex items-center space-x-2 text-lg font-semibold text-green-500 hover:text-green-600 lg:text-xl",
                                href: "/clientes",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "Explorar m\xe1s"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        className: "h-5 w-5 text-gray-400",
                                        viewBox: "0 0 20 20",
                                        fill: "currentColor",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            fillRule: "evenodd",
                                            d: "M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z",
                                            clipRule: "evenodd"
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section/* default */.Z, {
                className: "relative overflow-hidden bg-white bg-gradient-to-tl from-green-100 to-gray-100",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.ZP, {
                        className: "relative z-20 pt-10 lg:pt-20 lg:pb-20 xl:pt-32 xl:pb-32",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mx-auto w-full space-y-10",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "grid grid-cols-1 lg:grid-cols-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "lg:col-span-8",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "space-y-6",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                className: "text-lg font-bold tracking-tight text-green-500 lg:text-xl",
                                                children: "Nosotros"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                className: "text-4xl font-bold tracking-tight md:leading-relaxed lg:text-4xl lg:font-extrabold xl:text-6xl",
                                                children: "Somos la certificadora por excelencia preferida por hispanohablantes"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-lg text-gray-700 lg:pr-60 lg:text-xl",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "leading-relaxed",
                                                    children: "Ense\xf1amos a profesionales y empresas a aplicar los principios del desarrollo \xe1gil y certificamos sus competencias en el dominio de Scrum."
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "flex items-center lg:pt-4",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                    href: "/nosotros",
                                                    className: "inline-flex justify-center whitespace-nowrap rounded-full bg-green-500 px-10 py-3 text-center text-xl font-semibold leading-none text-white hover:bg-green-600 focus:bg-green-600 focus:outline-none focus:ring-4 focus:ring-green-800 focus:ring-opacity-20 md:text-lg lg:text-xl",
                                                    role: "button",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "font-semibold",
                                                        children: "Conoce m\xe1s sobre nosotros"
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "relative overflow-hidden lg:absolute lg:top-0 lg:bottom-0 lg:right-0 lg:-mr-80 lg:flex lg:w-full lg:items-center lg:justify-center xl:w-3/4",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "relative -mt-10 flex items-end justify-center pb-20 lg:-mt-40",
                            style: {
                                minHeight: 350
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Globe, {})
                        })
                    })
                ]
            })
        ]
    });
};
Home.layoutProps = {
    meta: {
        description: "Ayudamos a profesionales y empresas a aplicar los principios del desarrolo \xe1gil y certificamos sus competencias en el dominio del framework Scrum."
    }
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5675,6654,9774,2888,179], function() { return __webpack_exec__(75557); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);